import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { currentLanguage, changeLanguage, availableLanguages } = useLanguage();
  const { t } = useTranslation();


  return (
    <footer className="w-full px-2">
      <div className="border-t border-black" />

      {/* Main content */}
      <div className="w-full">
        <div className="w-full flex justify-between items-start">
          {/* Mobile layout */}
          <div className="flex md:hidden w-full pt-4 pb-[33px]">
            {/* {t('footer.links')} column */}
            <div className="flex-1">
              <h3 className="font-normal text-14">{t('footer.links')}</h3>
              <ul>
                <li><Link to="/" className="font-light text-14">{t('footer.shopAll')}</Link></li>
                <li><Link to="/shipping" className="font-light text-14">{t('footer.shipping')}</Link></li>
                <li><Link to="/terms" className="font-light text-14">{t('footer.terms')}</Link></li>
                <li><Link to="/returns" className="font-light text-14">{t('footer.returns')}</Link></li>
                <li><Link to="/legal" className="font-light text-14">{t('footer.legal')}</Link></li>
              </ul>
            </div>

            {/* Right column with {t('footer.contact')} and {t('footer.socials')} */}
            <div className="flex-1 flex flex-col space-y-[17px] pl-2">
              <div>
                <h3 className="font-normal text-14">{t('footer.contact')}</h3>
                <p className="font-light text-14">
                  <a href="mailto:hello@institutelab.co">hello@institutelab.co</a>
                </p>
              </div>

              <div>
                <h3 className="font-normal text-14">{t('footer.socials')}</h3>
                <ul className="font-light">
                  <li><a className="font-light text-14" href="https://www.instagram.com/institutelab">Instagram</a></li>
                  <li><a className="font-light text-14" href="https://www.facebook.com/institutelab">Facebook</a></li>
                </ul>
              </div>
            </div>
          </div>

          {/* Desktop layout */}
          <div className="hidden md:grid gap-2 grid-cols-4 w-full pt-4 pb-8">
            {/* {t('footer.links')} */}
            <div>
              <h3 className="font-normal text-14">{t('footer.links')}</h3>
              <ul className="">
                <li><Link to="/" className="font-light text-14">{t('footer.shopAll')}</Link></li>
                <li><Link to="/shipping" className="font-light text-14">{t('footer.shipping')}</Link></li>
                <li><Link to="/terms" className="font-light text-14">{t('footer.terms')}</Link></li>
                <li><Link to="/returns" className="font-light text-14">{t('footer.returns')}</Link></li>
                <li><Link to="/legal" className="font-light text-14">{t('footer.legal')}</Link></li>
              </ul>
            </div>

            {/* {t('footer.contact')} */}
            <div>
              <h3 className="font-normal text-14">{t('footer.contact')}</h3>
              <p className="font-light text-14">
                <a href="mailto:hello@institutelab.co">hello@institutelab.co</a>
              </p>
            </div>

            {/* {t('footer.socials')} */}
            <div>
              <h3 className="font-normal text-14">{t('footer.socials')}</h3>
              <ul className="font-light">
                <li><a className="font-light text-14" href="https://www.instagram.com/institutelab">Instagram</a></li>
                <li><a className="font-light text-14" href="https://www.facebook.com/institutelab">Facebook</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-black pt-2 pb-[10px] w-full">
        <div className="flex justify-between font-light text-10 w-full">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;